import { render, staticRenderFns } from "./Certificacion.vue?vue&type=template&id=20dd2727"
import script from "./Certificacion.vue?vue&type=script&lang=js"
export * from "./Certificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports